export default __webpack_public_path__ + "img/RoyalsLogo-01.png";